import styled from 'styled-components';

export const TextWrapper = styled.div`
  font-size: 16px;
  font-weight: 600;
`;
